<template>
  <div class="bg-brand-light-gray flex flex-col md:py-12">
    <div
      class="w-full md:max-w-screen-lg flex flex-col bg-white rounded-sm shadow mx-auto py-10 px-10 mt-5"
    >
      <h2 class="text-2xl pb-5">US Bank Level Security</h2>

      <h2 class="text-2xl pt-3">Get Started</h2>
      <Line />

      <p class="py-2 font-light">
        Rent Application Technology Services LLC ("Rent Application") takes security seriously.
      </p>
      <p class="py-2 font-light">
        By utilizing 256 bit SSL encryption and world-class secure server infrastructure, Rent
        Application keeps your documents private and secure. In addition to using SSL for secure
        communication we have selected a reputable and reliable hosting provider for our servers;
        AWS (https://aws.amazon.com/). Here's an overview of their security policies:
      </p>
      <h2 class="text-2xl pt-3">Physical Security</h2>
      <Line />
      <p class="py-2 font-light">
        Rent Application is hosted in a state-of-the-art SAS70 Type II facility that has achieved
        ISO 27001 certification.
      </p>
      <p class="py-2 font-light">
        On a physical level, security at each facility is made up of several layers. There is either
        a manned checkpoint or keycard access to get into the building itself (in some places, even
        the parking lot). Once inside the building, there are several layers of physical security
        before actually reaching our equipment, including biometric fingerprint, handprint, retina
        scan, key card, and PIN numbers. In some facilities you are even escorted to your area at
        this point, but most allow you to make your own way. All of our equipment is in locked
        cages, so even if someone was wandering free somehow, they would still need a key,
        thumbprint, or keycard to get into our locked cage.
      </p>
      <h2 class="text-2xl pt-3">Encryption</h2>
      <Line />
      <p class="py-2 font-light">
        Your connection to Rent Application is secure and encrypted using AES - 256 bit SSL (Secure
        Sockets Layer). This is the same level of encryption used by leading banks and government
        agencies. Your documents are also stored and encrypted at rest using AES - 256 bit
        encryption.
      </p>

      <h2 class="text-2xl pt-3">Network Security</h2>
      <Line />
      <p class="py-2 font-light">
        We have our own internal monitoring solutions in place which alerts us to any issues that
        may arise and address them as quickly and efficiently as possible. We cannot disclose any
        specific information about these security implementations as this information could
        potentially be used to circumvent these systems, however you can rest assured that we take a
        *proactive* approach toward the security of our network.
      </p>

      <h2 class="text-2xl pt-3">Daily Back-ups</h2>
      <Line />
      <p class="py-2 font-light">
        We back up our complete systems every day. All backup data is encrypted and securely stored
        on encrypted hard drives.
      </p>
      <h2 class="text-2xl pt-3">Credit Card Information</h2>
      <Line />
      <p class="py-2 font-light">
        Rent Application does not store your credit card information on its servers. When you submit
        your credit card information, we pass it along to our payments processor Stripe, a PCI
        Service Provider Level 1 service. Stripe processes online credit card payments for thousands
        of other companies including Fortune 500 companies, charitable organizations, and small
        businesses.
      </p>
    </div>
  </div>
  <Footer />
</template>
